module.exports = __webpack_public_path__ + "media/images/athletes/3422-048cfed4c89874b611329d9a5314e83c.png";